var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  default: () => DefinitionManager
});
module.exports = __toCommonJS(stdin_exports);
var import_getDSDataAtPath = __toESM(require("./utils/getDSDataAtPath"));
var import_mergeDataSchema = __toESM(require("./utils/mergeDataSchema"));
class DefinitionManager {
  constructor(root) {
    this.cache = {};
    this.root = root;
  }
  getRawDefinitionFromRoot(ref) {
    const parts = ref.split("/").slice(1);
    return (0, import_getDSDataAtPath.default)(this.root, parts);
  }
  getDefinition(ref) {
    const stack = [];
    while (ref) {
      if (ref in this.cache) {
        const cached = this.cache[ref];
        stack.push({ ref, schema: cached.schema });
        break;
      }
      if (stack.some((X) => X.ref === ref)) {
        throw new Error(`Found ref loop: ${stack.map((x) => x.ref).join(" -> ")} -? ${ref}`);
      }
      const rawDef = this.getRawDefinitionFromRoot(ref);
      if (!rawDef)
        throw new Error(`Unknown ref ${ref}`);
      stack.push({ ref, schema: rawDef });
      ref = rawDef.$ref;
    }
    if (!stack.length)
      return null;
    for (let i = stack.length - 2; i >= 0; i--) {
      const inheritFrom = stack[i + 1].schema;
      const newSchema = (0, import_mergeDataSchema.default)(inheritFrom, stack[i].schema);
      stack[i].schema = newSchema;
    }
    for (const { ref: ref2, schema, fromCache } of stack) {
      if (!fromCache)
        this.cache[ref2] = { ref: ref2, schema };
    }
    return stack[0].schema;
  }
}
